import React, { useMemo } from "react";
import { StripesConnectedSource, } from "@folio/stripes/smart-components";
import { useOkapiKy } from "@folio/stripes/core";
import { useIntl } from "react-intl";
import TableComponent from "../TableComponent";
import { buildDuplicateColumns, } from "./duplicateColumns";
var DuplicateTable = function (_a) {
    var duplicates = _a.duplicates, onDuplicateClick = _a.onDuplicateClick;
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var columns = useMemo(function () { return buildDuplicateColumns(formatMessage, onDuplicateClick); }, [formatMessage, onDuplicateClick]);
    var source = new StripesConnectedSource({}, ky);
    return (React.createElement(TableComponent, { data: duplicates, columns: columns, pageSize: duplicates.length, totalCount: duplicates.length, onNeedMoreData: function () { }, source: source, toggleFilterPane: function () { }, filterPaneIsVisible: false }));
};
export default DuplicateTable;
